import { DeleteOutlined } from "@ant-design/icons";
import { Card, Input, Space, Rate, Radio, Checkbox } from "antd";

const SurveyQuestionCardRender = ({
  surveyQuestions,
  setSurveyQuestions,
  showSuccessNotification
}) => {
  const handleDeleteQuestion = (index) => {
    const updatedQuestions = surveyQuestions.filter((_, i) => i !== index);
    setSurveyQuestions(updatedQuestions);
    showSuccessNotification("Question deleted successfully");
  };
  return (surveyQuestions || []).map((question, index) => {
    let inputComponent;

    if (question.type === "TEXT") {
      inputComponent = (
        <div>
          <Space direction="vertical">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <label>
                {question.title}
                {question.required && "*"}
              </label>
              <DeleteOutlined onClick={() => handleDeleteQuestion(index)} />
            </div>
            <Input placeholder="Your answer" required={question.required} />
          </Space>
        </div>
      );
    } else if (question.type === "RATING") {
      inputComponent = (
        <Space direction="vertical">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label>
              {question.title}
              {question.required && "*"}
            </label>
            <DeleteOutlined onClick={() => handleDeleteQuestion(index)} />
          </div>
          <Rate />
        </Space>
      );
    } else if (question.type === "MULTIPLE_CHOICE_SINGLE_SELECT") {
      inputComponent = (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label>
              {question.title}
              {question.required && "*"}
            </label>
            <DeleteOutlined onClick={() => handleDeleteQuestion(index)} />
          </div>
          <Radio.Group style={{ width: "100%" }}>
            {question.options.map((option) => (
              <Radio key={option.key} value={option.key}>
                {option.value}
              </Radio>
            ))}
          </Radio.Group>
        </div>
      );
    } else if (question.type === "MULTIPLE_CHOICE_MULTI_SELECT") {
      inputComponent = (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label>
              {question.title}
              {question.required && "*"}
            </label>
            <DeleteOutlined onClick={() => handleDeleteQuestion(index)} />
          </div>
          <Checkbox.Group style={{ width: "100%" }}>
            {question.options.map((option) => (
              <Checkbox key={option.key} value={option.key}>
                {option.value}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      );
    } else if (question.type === "CHECKBOX") {
      inputComponent = (
        <Checkbox required={question.required}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label>
              {question.title}
              {question.required && "*"}
            </label>
            <DeleteOutlined onClick={() => handleDeleteQuestion(index)} />
          </div>
        </Checkbox>
      );
    } else {
      inputComponent = <div>Unknown question type</div>;
    }

    return (
      <Card
        key={index}
        style={{
          borderLeft: "10px solid #1890ff",
          borderRadius: "10px",
          marginTop: "10px",
          marginBottom: "10px",
          padding: "1px"
        }}
      >
        {inputComponent}
      </Card>
    );
  });
};

export default SurveyQuestionCardRender;
